module.exports = __webpack_public_path__ + "static/opengraph-48fb9a43aff7fdff83219d97e843a2a6.jpg";